import React, { useState } from "react";

export default function RevealInfo({
    imageSrc,
    imageAlt = "",
    buttonLabel = "See what info you share",
    panelTitle = "Data Rights Forfeited",
    panelList = [],
    className = "",
    panelWidth = 400,  // tighter width for closer look
    gap = 0,          // reduced gap between image & panel
}) {
    const [open, setOpen] = useState(false);

    return (
        <div className={`w-full flex justify-center ${className}`}>
            <div className="relative flex flex-col items-center transition-all duration-500 ease-out max-w-[1200px] w-full">
                {/* Row wrapper */}
                <div className="flex flex-col md:flex-row items-start transition-all duration-500 ease-out">
                    {/* LEFT IMAGE */}
                    <div
                        className="relative transition-transform duration-500 ease-out"
                        style={{

                        }}
                    >
                        <img
                            src={imageSrc}
                            alt={imageAlt}
                            className="w-full max-w-[600px] max-h-[550px] rounded-sm shadow-sm block"
                        />
                        <div className="mt-5 text-center">
                            <button
                                onClick={() => setOpen(!open)}
                                aria-expanded={open}
                                aria-controls="info-panel"
                                className="px-6 py-3 bg-[#3B33FF] text-white font-semibold rounded-lg shadow-md hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3B33FF]"
                            >
                                {buttonLabel}
                            </button>
                        </div>
                    </div>

                    {/* RIGHT PANEL */}
                    <div
                        id="info-panel"
                        className="overflow-hidden transition-all duration-500 ease-out "
                        style={{
                            width: open ? `${panelWidth}px` : "0px",
                            opacity: open ? 1 : 0,
                        }}
                    >
                        <div
                            className="bg-white rounded-lg shadow-lg p-6 w-[420px]"
                            style={{
                                boxSizing: "border-box",
                            }}
                        >
                            <h3 className="text-xl font-semibold text-slate-900 mb-3">
                                {panelTitle}
                            </h3>
                            <ul className="list-disc ml-5 space-y-1 text-slate-700 text-[15px] leading-relaxed">
                                {panelList.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                            <div className="mt-5 text-right">
                                <button
                                    onClick={() => setOpen(false)}
                                    className="px-3 py-2 text-sm rounded-md border border-slate-200 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3B33FF]"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
